import { AppState } from "../rootReducer";

export const getUnsplashResults = (state: AppState) =>
  state.upload.unsplashResults;

export const getUploading = (state: AppState) => state.upload.uploading;

export const getUploadedPicture = (state: AppState) => state.upload.picture;

export const getFileNameUpload = (state: AppState) => state.upload.fileName;

export const getFileTypeUpload = (state: AppState) => state.upload.fileType;

export const getFileUploadProgress = (state: AppState) =>
  state.upload.uploadProgressPercent;

export const getFilesToUpload = (state: AppState) => state.upload.files || [];
